import {
    SYSTEM_LOG_REQUEST,
    SYSTEM_LOG_SUCCESS,
    SYSTEM_LOG_FAIL,
    TRANSACTION_LOG_REQUEST,
    TRANSACTION_LOG_SUCCESS,
    TRANSACTION_LOG_FAIL,
    USERS_LOG_REQUEST,
    USERS_LOG_SUCCESS,
    USERS_LOG_FAIL
} from '../constants/action-types';

const initialState = {
    fetching: false,
    error: '',
    logs: [],
    transactionlogs: [],
    users: [],
    hasMore: true,
}

export default function systemlogs(state = initialState, action) {
    switch (action.type) {
        case SYSTEM_LOG_REQUEST:
        case TRANSACTION_LOG_REQUEST:
        case USERS_LOG_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case SYSTEM_LOG_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: '',
                logs: action.payload.logs,
                hasMore: action.payload.hasMore,
            }
        case TRANSACTION_LOG_SUCCESS:
                return {
                ...state,
                fetching: false,
                error: '',
                transactionlogs: action.payload.transactionlogs,
                hasMore: action.payload.hasMore,
            }
        case USERS_LOG_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: '',
                users: action.payload,
            }
        case SYSTEM_LOG_FAIL:
        case TRANSACTION_LOG_FAIL:
        case USERS_LOG_FAIL:
            return {
                ...initialState,
                fetching: false,
                error: action.error || '',
            }
        default:
            return state;
  }

}



// WEBPACK FOOTER //
// ./source/reducers/systemlogs.js